import ChangePasswordForm from "../../components/formik/ChangePasswordForm.tsx";
import AuthLayout from "@/layout/AuthLayout.tsx";

export default function ChangePasswordView() {
    return (
        <AuthLayout title={"Reset Password"}>
            <ChangePasswordForm/>
        </AuthLayout>
    );
}
